
riot.tag2('new-categories-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Категории новостей</div>\n    </yield>\n    <yield to="body">\n      <catalog object="NewsCategory" cols="{parent.cols}" dblclick="{parent.opts.submit.bind(this)}" reload="true">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="title">{row.title}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.cols = [{ name: 'id', value: '#' }, { name: 'title', value: 'Наименование' }];
});


// WEBPACK FOOTER //
// ./pages/news/new-categories-list-modal.tag